import React from 'react';
import CourseCard from './CourseCard';
import image1 from "./img/imagen1.png"
import image2 from "./img/image2.png"

const courses = [
  {
    image: image1, // Asegúrate de ajustar esta ruta
    title: 'Como funciona el software GESTION EMPRESARIAL',
    description: ' Es la encargado de reclutar a los trabajadores, o en ocasiones contratan empresas para llevar a cabo este importante proceso de selección',
    date: 'Mon • enero 05',
    duration: '1h 30 min',
    tags: ['RECURSOS HUMANOS', 'SELECCION DE PERSONAL'],
  },
  {
    image: image2, // Asegúrate de ajustar esta ruta
    title: 'Administración de Recursos Humanos',
    description: 'Comprender la importancia del desarrollo estratégico en la gestión de capital humano',
    date: 'Fri • Febrero 23',
    duration: '4h 45 min',
    tags: ['RECURSOS HUMANOS', 'ADMINISTRACION DE PERSONAL'],
  },
];

const CourseList: React.FC = () => {
  return (
    <div className="p-4">
      <h1 className="text-1xl font-bold mb-4">
      Todos los cursos</h1>
      <div className="flex gap-4">
        {courses.map((course, index) => (
          <CourseCard key={index} {...course} />
        ))}
      </div>
    </div>
  );
};

export default CourseList;
